export { default as default } from './KitMapView';
